// extracted by mini-css-extract-plugin
export default {"ViewBlocking":"styles_ViewBlocking__qBPn7","row":"styles_row__Klahg","col":"styles_col__Sdnw7","deactivateButton":"styles_deactivateButton__oOqjl"};